import React, { useRef, useState } from "react";
import { useGLTF } from "@react-three/drei";

import { useLoader } from "@react-three/fiber";
import { TextureLoader } from "three";
import { useFrame } from "@react-three/fiber";

function Homex(props) {
  const { nodes, materials } = useGLTF(`${process.env.NEXT_PUBLIC_origin}/3D/final.gltf`);

  `${process.env.NEXT_PUBLIC_origin}/3D/final.gltf`;

  const boix = useLoader(TextureLoader, "/3D/bois.jpg");
  const murx = useLoader(TextureLoader, props.textureButton);
  const planOne = useLoader(TextureLoader, "/3D/etage1_1.jpg");
  const planTwo = useLoader(TextureLoader, "/3D/etage2.jpg");
  const maison = useRef();
  const roofScale = props.floorButton === "second" || props.floorButton === "first" ? 0 : 1;
  const secondScale = props.floorButton === "second" || props.floorButton === "roof" ? true : false;

  useFrame(() => maison.current && void (maison.current.rotation.y += props.speed));

  const metal_miror = 0.855;
  const rough_miror = 0;
  const opacity_miror = 0.8;

  const color_metal = "#3f7674";

  const dalle3Ref = useRef();

  const [etat3, setEtat3] = useState(true);
  const [etat2, setEtat2] = useState(true);

  return (
    <group {...props} dispose={null} ref={maison}>
      <mesh castShadow receiveShadow geometry={nodes["0-dalle1---"].geometry} position={[-0.94, 0.2, -0.54]} rotation={[-Math.PI / 2, 0, 0]}>
        <meshStandardMaterial map={murx} />
      </mesh>
      <mesh castShadow receiveShadow geometry={nodes["1-bois1"].geometry} position={[1.64, 2.56, -2.74]} rotation={[Math.PI / 2, 0, -1.57]} scale={[0.75, 0.75, 0.77]}>
        <meshStandardMaterial map={boix} />
      </mesh>
      <mesh castShadow receiveShadow geometry={nodes["2-bois1"].geometry} position={[3.52, 0.13, -0.71]} rotation={[-Math.PI / 2, 0, 0]} scale={0.75}>
        <meshStandardMaterial map={boix} />
      </mesh>
      <mesh castShadow receiveShadow geometry={nodes["3-bois1"].geometry} position={[0.75, -0.03, -4.74]} rotation={[-Math.PI / 2, 0, 0]} scale={[0.75, 0.75, 0.74]}>
        <meshStandardMaterial map={boix} />
      </mesh>

      <mesh geometry={nodes["4-porte1"].geometry} material={nodes["4-porte1"].material} position={[-3.93, 0.27, 0.07]} rotation={[-Math.PI / 2, 0, 0]} />

      <mesh castShadow receiveShadow geometry={nodes["5-miroir1"].geometry} position={[5.44, -2.27, 2.66]} rotation={[-Math.PI / 2, 0, Math.PI / 2]} scale={0.75}>
        <meshStandardMaterial displacementScale={0.5} roughness={rough_miror} metalness={metal_miror} transparent opacity={opacity_miror} />
      </mesh>

      <mesh geometry={nodes["6-fenetre1"].geometry} material={nodes["6-fenetre1"].material} position={[-0.65, 1.37, -0.42]} rotation={[-Math.PI / 2, 0, Math.PI / 2]} scale={0.75}>
        <meshStandardMaterial roughness={rough_miror} metalness={0} color={color_metal} wireframe_metal />
      </mesh>

      <mesh geometry={nodes["7-poto1"].geometry} material={nodes["7-poto1"].material} position={[-5.53, 0.16, -4.59]} rotation={[-Math.PI / 2, 0, 0]} scale={0.8}>
        <meshStandardMaterial map={murx} transparent={!etat3} opacity={etat3 ? 1 : 0} />
      </mesh>

      <mesh geometry={nodes["8-etage1---"].geometry} material={nodes["8-etage1---"].material} position={[-0.94, 3.79, -0.54]} rotation={[-Math.PI / 2, 0, 0]}>
        <meshStandardMaterial map={murx} transparent={!etat3} opacity={etat3 ? 1 : 0} />
      </mesh>

      <mesh geometry={nodes["9-dalle2---"].geometry} material={nodes["9-dalle2---"].material} position={[1.2, 2.79, -0.22]} rotation={[-Math.PI / 2, 0, 0]} scale={secondScale ? 1 : 0}>
        <meshStandardMaterial map={murx} transparent={!etat3} opacity={etat3 ? 1 : 0} />
      </mesh>

      <mesh castShadow receiveShadow geometry={nodes["10-miroir2----"].geometry} position={[0, 3.27, -0.11]} rotation={[Math.PI, 1.57, 0]} scale={secondScale ? 0.75 : 0}>
        <meshStandardMaterial displacementScale={0.5} roughness={rough_miror} metalness={metal_miror} transparent opacity={etat2 ? opacity_miror : 0} />
      </mesh>

      <mesh geometry={nodes["11-poto2"].geometry} material={nodes["11-poto2"].material} position={[-5.53, 2.8, -4.59]} rotation={[-Math.PI / 2, 0, 0]} scale={secondScale ? 0.8 : 0}>
        <meshStandardMaterial map={murx} transparent={!etat3} opacity={etat3 ? 1 : 0} />
      </mesh>

      <mesh
        castShadow
        receiveShadow
        geometry={nodes["12-bois2"].geometry}
        material={nodes["12-bois2"].material}
        position={[4.51, 4.06, -0.71]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={secondScale ? 0.75 : 0}
      >
        <meshStandardMaterial map={boix} />
      </mesh>

      <mesh
        geometry={nodes["13-fenetre21"].geometry}
        material={nodes["13-fenetre21"].material}
        position={[-2.1, 3.81, -3.53]}
        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
        scale={secondScale ? 0.75 : 0}
      >
        <meshStandardMaterial roughness={rough_miror} metalness={0} color={color_metal} wireframe_metal />
      </mesh>

      <mesh geometry={nodes["14-etage2"].geometry} material={nodes["14-etage2"].material} position={[0.44, 2.3, 0.04]} rotation={[-Math.PI / 2, 0, 0]} scale={secondScale ? 1 : 0}>
        <meshStandardMaterial map={murx} transparent={!etat3} opacity={etat3 ? 1 : 0} />
      </mesh>

      <mesh geometry={nodes["15-porte2"].geometry} material={nodes["15-porte2"].material} position={[-5.12, 2.8, -0.58]} rotation={[-Math.PI / 2, 0, Math.PI / 2]} scale={secondScale ? 1 : 0} />

      <mesh ref={dalle3Ref} castShadow receiveShadow geometry={nodes["16-dalle3---"].geometry} position={[0.04, 5.03, -0.22]} rotation={[-Math.PI / 2, 0, 0]} scale={roofScale}>
        <meshStandardMaterial map={murx} transparent={!etat3} opacity={etat3 ? 1 : 0} />
      </mesh>

      <mesh geometry={nodes["17-sol"].geometry} material={nodes["17-sol"].material} position={[-0.42, 0.08, -2.15]} rotation={[-Math.PI / 2, 0, 0]}>
        <meshStandardMaterial map={murx} transparent={!etat3} opacity={etat3 ? 1 : 0} />
      </mesh>

      <mesh geometry={nodes["18-plan-1"].geometry} material={nodes["18-plan-1"].material} position={[-0.71, 0.4, -0.54]} scale={[1, 1.5, 1]}>
        <meshStandardMaterial map={planOne} transparent={!etat3} opacity={etat3 ? 1 : 0} />
      </mesh>
      <mesh geometry={nodes["19-plan2"].geometry} material={nodes["19-plan2"].material} position={[0, 2.82, 0]} scale={props.floorButton === "second" ? [1, 1.5, 1] : 0}>
        <meshStandardMaterial map={planTwo} transparent={!etat3} opacity={etat3 ? 1 : 0} />
      </mesh>
    </group>
  );
}

useGLTF.preload("/3D/final.gltf");
export default Homex;
